import { useCurrentUser } from '../../services/userHooks';
import { getKindleEmail } from '../../utils/inboundEmail';
import CopyableEmail from './CopyableEmail';

/**
 * Renders the first Kindle setup step. When the user is signed in we already
 * have their address, so we skip the "go to instapaper.com/user" navigation and
 * just offer the address to copy. Logged out, we keep the full instructions.
 */
function KindleEmailStep() {
  const { currentUser } = useCurrentUser();
  const kindleEmail = getKindleEmail(currentUser);

  if (kindleEmail) {
    return (
      <>
        Copy your Instapaper Kindle email address: <CopyableEmail email={kindleEmail} />
      </>
    );
  }

  return (
    <>
      On{' '}
      <a
        href="https://www.instapaper.com/user"
        className="docs-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        instapaper.com/user
      </a>
      , scroll to the Kindle section and copy your Instapaper email address for Kindle
      (e.g. <code className="docs-code-inline">kindle.xxxxx@instapaper.com</code>)
    </>
  );
}

export default KindleEmailStep;
